// extracted by mini-css-extract-plugin
module.exports = {"container":"product-ratings_container__HFeXF","numberOfRatings":"product-ratings_numberOfRatings__5fttX"};